import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import CatalogoCatProgramatica from "../../catalogos/catalogoCategoriaProgramatica";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import CatalogoProveedorPresupuesto from "../../catalogos/catalogoProveedorm";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentaBancarias";


export const ImpEjeFinanciera3 = (props) => {
  // --- UTILIDADES ---
  let op = require("../../modulos/datos"); // Asegúrate de que esta ruta sea correcta
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const post = JSON.parse(localStorage.getItem("post"));
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [modoBanco, setModoBanco] = useState('seleccionar');

  // Radio buttons para banco
  const radioBancoSelectRef = useRef();
  const radioBancoIndividualRef = useRef();

  // Proveedor
  const provCodigoRef = useRef();
  const provNombreRef = useRef();

  // Banco
  const bancoCodigoRef = useRef();
  const bancoNombreRef = useRef();

  // Tipo de Ordenes (Resumen Check + Radios)
  const radioTipoOrdTodasRef = useRef();
  const radioTipoOrdPresupRef = useRef();
  const radioTipoOrdFinanRef = useRef();
  const radioTipoOrdTercerosRef = useRef();

  const [mostrar3, setMostrar3] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  // --- REFS UTILIZADOS ---
  const txt1 = useRef(); // Sector
  const txt2 = useRef(); // Prog
  const txt3 = useRef(); // SubProg
  const txt4 = useRef(); // Proy
  const txt5 = useRef(); // Act
  const btnCat = useRef();

  const checkResumenRef = useRef(); // Checkbox "Solo Alcadia"
  const fechaDesdeRef = useRef();
  const fechaHastaRef = useRef();
  const tipoCompromisoRef = useRef();

  // --- ESTADOS ---
  const [modoProveedor, setModoProveedor] = useState('seleccionar'); // 'seleccionar' o 'todos'
  const titulo = {
    127: 'Rendicion Informativa Impuesto 1x500',
    128: 'Rendcion Impuesto Actividades Económicas'

  };

  const cerrar = () => {
    props.cancelar();
  };




  // --- FUNCIÓN IMPRIMIR ---
  const imprimir = () => {

  };

  const onHideCuentaBancaria = (values) => {
    setMostrar(false)
    console.log(values)
    bancoCodigoRef.current.value = values.idcuentabancaria;
    bancoNombreRef.current.value = values.nombre.trim() + ' / ' + values.cuentabancaria;
  }

  const onHideAceptaCatProv = (responsable, razonsocial, idproveedor, rif) => {
    setMostrar2(false)
    console.log(responsable, razonsocial, idproveedor, rif)
    provCodigoRef.current.value = idproveedor
    provNombreRef.current.value = razonsocial + ' ' + rif
  }

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          {titulo[props.reporte]} {props.reporte}
        </h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 row mx-auto px-0">
            

          {props.reporte === 127 || props.reporte === 128 ?
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Buscar por Orden de Pago</legend>
              <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Código:</span>
                <input
                
                  disabled
                  type="text"
                  className="form-control text-uppercase "
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button  type="button" className="btn btn-success"><i className="fas fa-search"></i></button>
               
              </div>
            </fieldset>
            : ''}

        </div>

        <Mensaje mensaje={mensaje}
          onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />



        <CatalogoProveedorPresupuesto
          show={mostrar2}
          onHideCancelar={() => setMostrar2(false)}
          onHideAceptaProveedor={onHideAceptaCatProv}

        />


        <CatalogoCuentaBancaria
          show={mostrar}
          onHideCancelar={() => setMostrar(false)}
          onHideAceptaCatalogo={onHideCuentaBancaria}

        />

      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-primary text-uppercase" onClick={imprimir}>
          <i className="fas fa-print me-2"></i> Imprimir
        </button>
        <button className="btn btn-sm btn-secondary text-uppercase" onClick={cerrar}>
          <i className="fas fa-times me-2"></i> Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};